"use strict";
/**
 * Shared vocabulary for classifying a GHE REST API response.
 *
 * Every Lambda that talks to GHE (repo-discovery, repo-scanner, ...) routes
 * its retry/record decision off this one classification instead of each call
 * site re-guessing behavior from a raw status code. The classifying function
 * itself (`classifyGheResponse`) lives in `@sdd-maturity/lambda-utils` — this
 * package only owns the shared result vocabulary, so every producer and
 * consumer agrees on the same four literal values (never re-declared per
 * Lambda).
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ghe-resilience.js.map